var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{ref:"chartContainer",staticStyle:{"width":"100%","height":"600px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }